import { cameraState, type CameraState } from '@/lib/threeScene/camera';

/**
 * Build the {@link CameraState} for an orthographic 2D image viewer.
 *
 * Bakes the image-viewer invariants — orthographic projection, orbit
 * controls with rotation disabled — and lets callers vary the
 * scene-specific bits (frustum height, near/far range, initial pose,
 * mouse-button mode) via `Partial<CameraState>`.
 *
 * Used by X-ray scenes, the DICOM overlay catstack, the prototype landmarks
 * playground, and the hip-spine xray scene.
 */
export function createImageViewerCameraState(
    options: Partial<CameraState> = {},
): CameraState {
    return cameraState({
        ...options,
        allowRotation: false,
    });
}
